"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingDeployButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const provider_user_1 = require("@dzambalaorg/provider-user");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const deployStaking_json_1 = __importDefault(require("@framework/abis/json/StakingFactoryFacet/deployStaking.json"));
const dialogs_1 = require("../../../../dialogs");
const initialValues = {
    contractTemplate: types_1.StakingContractTemplates.SIMPLE,
};
const StakingDeployButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { handleDeployConfirm } = (0, react_hooks_eth_1.useDeploy)(async (values, sign, systemContract) => {
        const nonce = sign.nonce;
        return writeContractAsync({
            address: systemContract.address,
            abi: deployStaking_json_1.default,
            functionName: "deployStaking",
            args: [
                {
                    nonce,
                    bytecode: sign.bytecode,
                    externalId: BigInt(profile.id),
                },
                {
                    contractTemplate: Object.values(types_1.StakingContractTemplates).indexOf(values.contractTemplate).toString(),
                },
                sign.signature,
            ],
        });
    });
    const onDeployConfirm = ({ data, form }) => {
        return handleDeployConfirm({
            url: "/contract-manager/staking",
            method: "POST",
            data,
        }, form);
    };
    const handleDeploy = () => {
        openDialog(dialogs_1.GlobalDialogKeys.STAKING_CONTRACT_DEPLOY, initialValues, {
            initialValues,
            message: "dialogs.deploy",
            testId: "StakingDeployForm",
            onExternalConfirm: onDeployConfirm,
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDeploy, icon: icons_material_1.Add, message: "form.buttons.deploy", className: className, dataTestId: "StakingDeployButton", disabled: disabled, variant: variant }));
};
exports.StakingDeployButton = StakingDeployButton;
//# sourceMappingURL=index.js.map